
import React from 'react';
import { PricingSection } from '../components/PricingSection';
import { useSEO } from '../hooks/useSEO';
import { useI18n } from '../i18n/i18n';

const PricingPage: React.FC = () => {
  const { t } = useI18n();
  
  // SEO Configuration
  const seoContent = useSEO('main', 'pricing');

  return (
    <div className="min-h-screen bg-[#F9FAFB]">
      {seoContent}
      <PricingSection showTitle={true} className="pt-8 bg-[#F9FAFB]" />
    </div>
  );
};

export default PricingPage;
